import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { messageSlice } from "../../../entities/message/model";
import { settingsSlice } from "../../../entities/settings/model";
import { captchaSlice } from "../../../entities/captcha/model";
import { filtersSlice } from "../../../entities/filters/model";
import { socketSlice } from "../../../entities/socket/model";
import { userSlice } from "../../../entities/user/model";
import { contentSlice } from "../../../entities/content/model";
export var reducer = combineReducers({
  socket: socketSlice.reducer,
  user: userSlice.reducer,
  settings: settingsSlice.reducer,
  filters: filtersSlice.reducer,
  message: messageSlice.reducer,
  captcha: captchaSlice.reducer,
  content: contentSlice.reducer
});
export var store = configureStore({
  reducer: reducer
});